import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import lodashCompact from 'lodash/fp/compact';

import {
  getShowingsInUpcomingTour,
} from 'common/tourHelpers';
import {
  hasRoleAgent,
  hasRoleSunroomClub,
} from 'common/userRoles';

import branch from 'client/core/branch';
import UserActions from 'client/actions/User';
import TourActions from 'client/actions/Tour';
import SrLink from 'client/components/SrLink/SrLink';

@withRouter
@branch({
  newBookmarksCount: ['newBookmarksCount'],
  tours: ['tours'],
  currentUserRoles: ['currentUser', 'roles'],
  tourCartTooltipClosed: [
    'currentUser',
    'settings',
    'tourCartTooltipClosed',
  ],
})
class TabBar extends Component {
  static propTypes = {
    newBookmarksCount: PropTypes.number.isRequired,
    tours: PropTypes.array,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  _onTourCartOnboardingTooltipCloseClick = () => {
    const { history, dispatch } = this.props;
    history.push('/tour');
    dispatch(UserActions.updateSettings, {
      tourCartTooltipClosed: true,
    });
  }

  _onTourCartShowingAddedTooltipCloseClick = () => {
    const { history, dispatch } = this.props;
    history.push('/tour');
    dispatch(TourActions.hideAddedToCartTooltip);
  }

  render() {
    const {
      location,
      newBookmarksCount,
      tours,
      currentUserRoles,
    } = this.props;

    const showingsInUpcomingTour = getShowingsInUpcomingTour(tours);

    let tabs = lodashCompact([
      {
        id: 'explore',
        label: 'Home',
        link: '/feed',
        additionalLinks: [],
      },
      {
        id: 'search',
        label: 'Search',
        link: '/address-search',
        additionalLinks: [],
      },
      {
        id: 'bookmarks',
        label: 'Saved',
        link: '/saved',
        additionalLinks: [],
        badge: (newBookmarksCount || 0),
      },
      {
        id: 'tour',
        label: 'Tours',
        link: '/tour',
        badge: showingsInUpcomingTour.length || 0,
        badgeClassName: showingsInUpcomingTour.length ? 'yellow' : null,
        additionalLinks: [
          '/tour/saved',
          '/tour/completed',
        ],
      },
      {
        id: 'profile',
        label: 'Profile',
        link: '/profile',
        additionalLinks: [],
        // Using a blank space to render an empty badge icon in this tabbar item.
        badge: hasRoleSunroomClub(currentUserRoles) ? '' : ' ',
        badgeClassName: 'yellow',
      },
    ]);

    if (hasRoleAgent(currentUserRoles)) {
      tabs = tabs.filter((tab) => tab.id !== 'search');
    }

    const currentTabId = (tabs.find(({ link, additionalLinks }) => {
      return location.pathname === link || additionalLinks.includes(location.pathname);
    }) || {}).id;

    return (
      <div className='tabBar'>
        <div className='tabContainer clearfix'>
          {tabs.map((tab) => {
            return (
              <SrLink
                key={tab.id}
                className={classnames('tab', tab.id, { active: currentTabId === tab.id })}
                to={tab.link}
              >
                <span className='icon' />
                {!!tab.badge && (
                  <span className={classnames('badge', tab.badgeClassName)}>
                    {tab.badge}
                  </span>
                )}
                <span className='title'>{tab.label}</span>
              </SrLink>
            );
          })}
        </div>
      </div>
    );
  }
}

TabBar.displayName = 'TabBar';

export default TabBar;
